import ApiService from './ApiService'

// Admin scoped lists
export const apiListRoles = data => ApiService.get('/admin/list/roles', data)
export const apiListVendors = () => ApiService.get('/admin/list/vendors')
export const apiListBankAccounts = () => ApiService.get('/admin/list/bank-accounts')
export const apiListBrands = () => ApiService.get('/admin/list/brands')
export const apiListCategories = id => ApiService.get(`/admin/list/categories/${id}`)
export const apiListExpenses = () => ApiService.get('/admin/list/expenses')
export const apiListStores = () => ApiService.get('/admin/list/stores')
export const apiListCustomers = data => ApiService.get('/admin/list/customers', data)
export const apiListReferrals = () => ApiService.get('/admin/list/referrals')
export const apiListProducts = () => ApiService.get('/admin/list/products')
export const apiListPurchases = id => ApiService.get(`/admin/list/purchases/${id}`)
export const apiListStoreOrders = id => ApiService.get(`/admin/list/store-orders/${id}`)
export const apiListOrders = id => ApiService.get(`/admin/list/orders/${id}`)

// Admins
export const apiAdminsList = data => ApiService.get('/admin/admins', data)
export const apiAdminsView = id => ApiService.get(`/admin/admins/${id}`)
export const apiAdminsForm = (id, data) => ApiService.post(`/admin/admins${id ? `/${id}` : ''}`, data)
export const apiAdminsStatus = id => ApiService.post(`/admin/admins/${id}/status`)
export const apiAdminsVerified = id => ApiService.post(`/admin/admins/${id}/verified`)

// Login History
export const apiLoginHistoryList = data => ApiService.get('/admin/login-history', data)

// Roles & Permissions
export const apiPermissions = () => ApiService.get('/admin/permission-datas')
export const apiRolesList = data => ApiService.get('/admin/roles', data)
export const apiRolesView = id => ApiService.get(`/admin/roles/${id}`)
export const apiRolesForm = (id, data) => ApiService.post(`/admin/roles${id ? `/${id}` : ''}`, data)
export const apiRolesStatus = id => ApiService.post(`/admin/roles/${id}/status`)

// Users
export const apiUsersList = data => ApiService.get('/admin/users', data)
export const apiUsersView = id => ApiService.get(`/admin/users/${id}`)
export const apiUsersForm = (id, data) => ApiService.post(`/admin/users${id ? `/${id}` : ''}`, data)
export const apiUsersStatus = id => ApiService.post(`/admin/users/${id}/status`)
export const apiUsersVerified = id => ApiService.post(`/admin/users/${id}/verified`)

// Stores
export const apiStoresList = data => ApiService.get('/admin/stores', data)
export const apiStoresView = id => ApiService.get(`/admin/stores/${id}`)
export const apiStoresForm = (id, data) => ApiService.post(`/admin/stores${id ? `/${id}` : ''}`, data)
export const apiStoresStatus = id => ApiService.post(`/admin/stores/${id}/status`)
export const apiStoresLockStatus = id => ApiService.post(`/admin/stores/${id}/lock-status`)

// Store Users
export const apiStoreUsersList = data => ApiService.get('/admin/store-users', data)
export const apiStoreUsersView = id => ApiService.get(`/admin/store-users/${id}`)
export const apiStoreUsersForm = (id, data) => ApiService.post(`/admin/store-users${id ? `/${id}` : ''}`, data)
export const apiStoreUsersStatus = id => ApiService.post(`/admin/store-users/${id}/status`)
export const apiStoreUsersVerified = id => ApiService.post(`/admin/store-users/${id}/verified`)

// Bank Accounts
export const apiBankAccountsList = data => ApiService.get('/admin/bank-accounts', data)
export const apiBankAccountsView = id => ApiService.get(`/admin/bank-accounts/${id}`)
export const apiBankAccountsForm = (id, data) => ApiService.post(`/admin/bank-accounts${id ? `/${id}` : ''}`, data)
export const apiBankAccountsStatus = id => ApiService.post(`/admin/bank-accounts/${id}/status`)

// Bank Transactions
export const apiBankTransactionsList = data => ApiService.get('/admin/bank-transactions', data)
export const apiBankTransactionsForm = (id, data) => ApiService.post(`/admin/bank-transactions${id ? `/${id}` : ''}`, data)
export const apiBankTransactionsExport = data => ApiService.get('/admin/bank-transactions-export', data)

// Wallet Transactions
export const apiWalletTransactionsList = data => ApiService.get('/admin/wallet-transactions', data)
export const apiWalletTransactionsForm = (id, data) => ApiService.post(`/admin/wallet-transactions${id ? `/${id}` : ''}`, data)
export const apiWalletTransactionsExport = data => ApiService.get('/admin/wallet-transactions-export', data)

// Brands
export const apiBrandsList = data => ApiService.get('/admin/brands', data)
export const apiBrandsView = id => ApiService.get(`/admin/brands/${id}`)
export const apiBrandsForm = (id, data) => ApiService.post(`/admin/brands${id ? `/${id}` : ''}`, data)
export const apiBrandsStatus = id => ApiService.post(`/admin/brands/${id}/status`)

// Categories
export const apiCategoriesList = data => ApiService.get('/admin/categories', data)
export const apiCategoriesView = id => ApiService.get(`/admin/categories/${id}`)
export const apiCategoriesForm = (id, data) => ApiService.post(`/admin/categories${id ? `/${id}` : ''}`, data)
export const apiCategoriesStatus = id => ApiService.post(`/admin/categories/${id}/status`)

// Attributes
export const apiAttributesList = data => ApiService.get('/admin/attributes', data)
export const apiAttributesView = id => ApiService.get(`/admin/attributes/${id}`)
export const apiAttributesForm = (id, data) => ApiService.post(`/admin/attributes${id ? `/${id}` : ''}`, data)
export const apiAttributesStatus = id => ApiService.post(`/admin/attributes/${id}/status`)

// Expenses
export const apiExpensesList = data => ApiService.get('/admin/expenses', data)
export const apiExpensesView = id => ApiService.get(`/admin/expenses/${id}`)
export const apiExpensesForm = (id, data) => ApiService.post(`/admin/expenses${id ? `/${id}` : ''}`, data)
export const apiExpensesStatus = id => ApiService.post(`/admin/expenses/${id}/status`)

// Customers
export const apiCustomersList = data => ApiService.get('/admin/customers', data)
export const apiCustomersView = id => ApiService.get(`/admin/customers/${id}`)
export const apiCustomersForm = (id, data) => ApiService.post(`/admin/customers${id ? `/${id}` : ''}`, data)
export const apiCustomersStatus = id => ApiService.post(`/admin/customers/${id}/status`)
export const apiCustomersLockStatus = id => ApiService.post(`/admin/customers/${id}/lock-status`)
export const apiCustomersClear = id => ApiService.post(`/admin/customers/${id}/clear`)

// Vendors
export const apiVendorsList = data => ApiService.get('/admin/vendors', data)
export const apiVendorsView = id => ApiService.get(`/admin/vendors/${id}`)
export const apiVendorsForm = (id, data) => ApiService.post(`/admin/vendors${id ? `/${id}` : ''}`, data)
export const apiVendorsStatus = id => ApiService.post(`/admin/vendors/${id}/status`)

// Referrals
export const apiReferralsList = data => ApiService.get('/admin/referrals', data)
export const apiReferralsView = id => ApiService.get(`/admin/referrals/${id}`)
export const apiReferralsForm = (id, data) => ApiService.post(`/admin/referrals${id ? `/${id}` : ''}`, data)
export const apiReferralsStatus = id => ApiService.post(`/admin/referrals/${id}/status`)

// Products
export const apiProductsList = data => ApiService.get('/admin/products', data)
export const apiProductsView = id => ApiService.get(`/admin/products/${id}`)
export const apiProductsForm = (id, data) => ApiService.post(`/admin/products${id ? `/${id}` : ''}`, data)
export const apiProductsStatus = id => ApiService.post(`/admin/products/${id}/status`)
export const apiProductsStoreStatus = (id, data) => ApiService.post(`/admin/products/${id}/store-status`, data)
export const apiProductsExport = data => ApiService.get('/admin/products-export', data)
export const apiProductsImport = data => ApiService.post('/admin/products-import', data)

// Purchases
export const apiPurchasesProducts = data => ApiService.get('/admin/purchases/products', data)
export const apiPurchasesList = data => ApiService.get('/admin/purchases', data)
export const apiPurchasesView = id => ApiService.get(`/admin/purchases/${id}`)
export const apiPurchasesForm = (id, data) => ApiService.post(`/admin/purchases${id ? `/${id}` : ''}`, data)
export const apiPurchasesStatus = (id, data) => ApiService.post(`/admin/purchases/${id}/status`, data)
export const apiPurchasesDelete = id => ApiService.destroy(`/admin/purchases/${id}`)
export const apiPurchasesInvoice = id => ApiService.get(`/admin/purchases/${id}/invoice`, null, { responseType: 'blob' })
export const apiPurchasesReturn = (id, data) => ApiService.post(`/admin/purchases/${id}/return`, data)

// Store Orders
export const apiStoreOrdersProducts = data => ApiService.get('/admin/store-orders/products', data)
export const apiStoreOrdersList = data => ApiService.get('/admin/store-orders', data)
export const apiStoreOrdersView = id => ApiService.get(`/admin/store-orders/${id}`)
export const apiStoreOrdersForm = (id, data) => ApiService.post(`/admin/store-orders${id ? `/${id}` : ''}`, data)
export const apiStoreOrdersStatus = (id, data) => ApiService.post(`/admin/store-orders/${id}/status`, data)
export const apiStoreOrdersDelete = id => ApiService.destroy(`/admin/store-orders/${id}`)
export const apiStoreOrdersInvoice = id => ApiService.get(`/admin/store-orders/${id}/invoice`, null, { responseType: 'blob' })
export const apiStoreOrdersReturn = (id, data) => ApiService.post(`/admin/store-orders/${id}/return`, data)

// Orders
export const apiOrdersProducts = data => ApiService.get('/admin/orders/products', data)
export const apiOrdersList = data => ApiService.get('/admin/orders', data)
export const apiOrdersView = id => ApiService.get(`/admin/orders/${id}`)
export const apiOrdersForm = (id, data) => ApiService.post(`/admin/orders${id ? `/${id}` : ''}`, data)
export const apiOrdersStatus = (id, data) => ApiService.post(`/admin/orders/${id}/status`, data)
export const apiOrdersDelete = id => ApiService.destroy(`/admin/orders/${id}`)
export const apiOrdersInvoice = id => ApiService.get(`/admin/orders/${id}/invoice`, null, { responseType: 'blob' })
export const apiOrdersReturn = (id, data) => ApiService.post(`/admin/orders/${id}/return`, data)
